<template>
    <div id="navbar-component" :class="mode == 'dark' ? 'dark' : 'light'">
        <div uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky">
            <nav class="uk-navbar-container" uk-navbar>

                <!-- Left side of the navabar -->
                <div class="uk-navbar-left">
                    <router-link to="/" class="uk-navbar-item uk-logo">
                        <img src="@/assets/chad-farm-logo.svg" alt="Harvest Finance" width="76" height="76" class="uk-margin-small-right">
                        Harvest
                    </router-link>
                </div>

                <!-- Center of the navbar: visible on larger devices only -->
                <div class="uk-navbar-center uk-visible@m">
                    <ul class="uk-navbar-nav">
                        <li><router-link to="/">Farm</router-link></li>
                        <li><router-link to="/stake">Stake</router-link></li>
                        <li><router-link to="/faq">FAQ</router-link></li>
                        <li><a href="https://harvestfi.github.io/dashboard/" target="_blank">Dashboard</a></li>
                        <li><a href="https://farm.chainwiki.dev/en/home" target="_blank">Wiki</a></li>
                        <li><a href="https://farm.chainwiki.dev/zh/%E7%AD%96%E7%95%A5" target="_blank">策略</a></li>
                    </ul>
                </div>

                <!-- Right side of the navbar: visible on larger devices only -->
                <div class="uk-navbar-right uk-visible@m">
                    <ul class="uk-navbar-nav"> 
                        <li class="uk-navbar-item" id="theme-changer" @click="changeTheme"><fa-icon :icon="mode == 'light' ? ['fas', 'sun'] : ['fas', 'moon']" size="lg"></fa-icon></li>
                        <li class="uk-navbar-item" id="active_address">Connected: 0x6d25...c262</li>
                    </ul>
                </div>

                <!-- Right side of the navbar: visible on small devices -->
                <div class="uk-navbar-right uk-hidden@m">
                    <ul class="uk-navbar-nav">
                        <li class="uk-navbar-item" id="theme-changer" @click="changeTheme"><fa-icon :icon="mode == 'light' ? ['fas', 'sun'] : ['fas', 'moon']" size="lg"></fa-icon></li>
                        <li><a href="#mobile-navbar" uk-toggle><fa-icon icon="bars" size="lg"></fa-icon></a></li>
                    </ul>
                </div>

            </nav>
        </div>

        <div id="mobile-navbar" uk-offcanvas="flip: true">
            <div class="uk-offcanvas-bar uk-flex uk-flex-column">
                <button class="uk-offcanvas-close" type="button" uk-close></button>
                <ul class="uk-nav uk-nav-primary uk-nav-center uk-margin-auto-vertical">
                    <li><router-link to="/">Farm</router-link></li>
                    <li><router-link to="/stake">Stake</router-link></li>
                    <li><router-link to="/faq">FAQ</router-link></li>
                    <li><a href="https://harvestfi.github.io/dashboard/" target="_blank">Dashboard</a></li>
                    <li><a href="https://farm.chainwiki.dev/en/home" target="_blank">Wiki</a></li>
                    <li><a href="https://farm.chainwiki.dev/zh/%E7%AD%96%E7%95%A5" target="_blank">策略</a></li>
                    <li class="uk-margin-large-top">Connected: 0x6d25...c262</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Navbar',
    props: {
        mode: String
    },
    methods: {
        changeTheme() {
            this.$emit('theme-changed');
        }
    }
}
</script>

<style lang="less" scoped>
    @import '../../dark-components/navbar.less';

    .uk-navbar-container {
        background-color: fade(lighten(@champagne-pink, 15%), 70%) !important;
        backdrop-filter: blur(5px);
    }

    .uk-logo {
        font-family: 'Lato';
        font-weight: 700;
        .fluid-font(1.5, 15, 320, 3840);
        color: @dark-red;
        transition: color .3s ease-in-out;
    }

    .uk-logo:hover {
        color: @brand-color;
        transition: color .3s ease-in-out;
    }

    .uk-navbar-nav {
        a {
            font-family: 'Lato';
            font-weight: 700;
            .fluid-font(.9, 6, 320, 3840);
            color: @text-color;
            transition: color .2s ease-in-out;
        }

        a:hover {
            color: @brand-color;
            transition: color .2s ease-in-out;
        }

        a.active {
            color: @brand-color !important;
        }
    }

    .uk-offcanvas-bar {
        background-color: lighten(@champagne-pink, 15%);

        button.uk-offcanvas-close {
            color: @text-color;
        }
    }

    .uk-offcanvas-bar .uk-nav li {

        font-family: 'Lato';
        font-weight: 700;
        color: @text-color;
        transition: color .2s ease-in-out;

        a {
            font-family: 'Lato';
            font-weight: 700;
            .fluid-font(1.5, 4, 320, 3840);
            color: @text-color;
            transition: color .2s ease-in-out;
        }

        a:hover {
            color: @brand-color;
            transition: color .2s ease-in-out;
        }

        a.active {
            color: @brand-color !important;
        }
    }

    #active_address {
        font-family: 'Lato';
        font-weight: 700;
        .fluid-font(1, 5, 320, 3840);
        color: @dark-red;
    }

    #theme-changer {
        cursor: pointer;
        font-family: 'Lato';
        font-weight: 700;
        .fluid-font(1, 5, 320, 3840);
        color: @brand-color;
    }

    @media only screen and (min-width: 2560px) {
        .uk-logo img {
            width: 100px;
            height: 100px;
        }
    }
</style>